import type { ReactNode } from 'react';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { cn } from '@/app/utils';
import { Button } from '../ui/button';

export const ButtonTab = <ValueType extends string>({
  className,
  buttonClassName,
  active,
  onChange,
  options,
}: {
  className?: string;
  buttonClassName?: string;
  active: ValueType;
  onChange: (value: ValueType) => void;
  options: { value: ValueType; label: string | ReactNode; tooltip?: string }[];
}) => {
  return (
    <div className={cn('mx-auto w-fit rounded-12 bg-system-bg04 p-1', className)}>
      {options.map((option) => (
        <CustomTooltip content={option.tooltip} key={option.value}>
          <Button
            className={cn(
              'h-9 rounded-10 px-7 py-2 text-sm text-system-white opacity-50 aria-selected:bg-system-bg02 aria-selected:opacity-100 md:px-3 lg:text-xs',
              buttonClassName,
            )}
            variant="text"
            aria-selected={active === option.value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        </CustomTooltip>
      ))}
    </div>
  );
};
